export const trackingHoursConfirmationMessage = () => {
    return '¿Esta seguro de enviar las horas? (Si desea modificarlas luego, tendría que hablar con el administrador, el cual estará muy enojado)';
}

